/* MERIDIAN preorder. Only installed when its native product block is rendered. */
(() => {
  if (window.spkMeridianPreorderBound) return;
  window.spkMeridianPreorderBound = true;
  const giftProperty = '_spk_meridian_preorder';
  const base = () => window.Shopify?.routes?.root || '/';
  async function request(path, body) {
    const response = await fetch(base() + path, body === undefined
      ? {headers: {Accept: 'application/json'}, cache: 'no-store'}
      : {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || 'Cart request failed');
    return data;
  }
  function giftLines(cart, giftId) {
    return (cart.items || []).filter(item => String(item.variant_id || item.id) === giftId && item.properties?.[giftProperty] === '1');
  }
  async function restoreGiftQuantity(giftId, previousQuantity) {
    let cart = await request('cart.js');
    let remaining = Math.max(0, giftLines(cart, giftId).reduce((sum, item) => sum + item.quantity, 0) - previousQuantity);
    // Read current keys because discount application can change line keys.
    for (const line of giftLines(cart, giftId)) {
      if (!remaining) break;
      const remove = Math.min(line.quantity, remaining);
      await request('cart/change.js', {id: line.key, quantity: line.quantity - remove});
      remaining -= remove;
    }
  }
  function clearOfferError(offer) {
    const error = offer?.querySelector('[data-meridian-gift-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-meridian-gift]')) clearOfferError(event.target.closest('[data-spk-meridian-preorder]'));
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const holder = form.closest('product-info');
    const offer = holder?.querySelector('[data-spk-meridian-preorder]');
    if (!offer || offer.dataset.formId !== form.getAttribute('id')) return;
    clearOfferError(offer);
    if (!offer.querySelector('[data-meridian-gift]')?.checked) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (!variantId || !button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (offer.dataset.busy === 'true') return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    offer.dataset.busy = 'true';
    button.disabled = true;
    button.classList.add('is-loading');
    const error = offer.querySelector('[data-meridian-gift-error]');
    error.hidden = true;
    const quantity = Math.max(1, Math.floor(Number(form.elements.namedItem('quantity')?.value) || 1));
    const giftId = offer.dataset.giftId;
    let previousQuantity = 0;
    let added = false;
    let addAttempted = false;
    let restored = false;
    try {
      const before = await request('cart.js');
      previousQuantity = giftLines(before, giftId).reduce((sum, item) => sum + item.quantity, 0);
      const formData = new FormData(form);
      const main = {id: Number(variantId), quantity};
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      if (Object.keys(properties).length) main.properties = properties;
      if (formData.get('selling_plan')) main.selling_plan = formData.get('selling_plan');
      addAttempted = true;
      await request('cart/add.js', {items: [main, {id: Number(giftId), quantity, properties: {[giftProperty]: '1'}}]});
      added = true;
      const oldCodes = (before.discount_codes || []).map(item => item.code).filter(Boolean);
      const codes = [...new Set([...oldCodes, offer.dataset.discountCode].filter(Boolean))];
      const cart = await request('cart/update.js', {discount: codes.join(',')});
      const applies = (cart.discount_codes || []).some(item => item.code.toUpperCase() === offer.dataset.discountCode.toUpperCase() && item.applicable);
      if (!applies) {
        await restoreGiftQuantity(giftId, previousQuantity);
        restored = true;
        error.textContent = offer.dataset.offerError;
        error.hidden = false;
      }
      button.dispatchEvent(new CustomEvent('theme:product:add', {bubbles: true, detail: {button, response: cart}}));
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      if (offer.dataset.surface === 'dawn' || window.theme?.settings?.cartType === 'page') window.location.assign(base() + 'cart');
    } catch (failure) {
      // Never leave newly added full-price lenses after a failed offer request.
      if (addAttempted && !restored) {
        try { await restoreGiftQuantity(giftId, previousQuantity); } catch (rollbackFailure) { console.error('MERIDIAN gift rollback failed', rollbackFailure); }
      }
      error.textContent = added ? offer.dataset.offerError : offer.dataset.requestError;
      error.hidden = false;
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
      delete offer.dataset.busy;
    }
  }, true);
})();

